<template>
  <div class="newPatient-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
          <div class="main-header-left">
            <span class="parent-link"  @click="navToHome()" >Admin</span>
            <span> >> </span>
            <span>EasyView Accounts Management</span>
          </div>
          <!--<div class="main-header-right" :class="{'de22':isDe||isFr,'cz22':isCz}">
            <img src="../../assets/back.png">
            <p  @click="back">{{$t('home')}}</p>
          </div>-->
        </div>
        <hr class="small-hr">

        <div v-show="tabA">
          <div class="item-wrap">
            <div class="item intro-text">
              <p>Please submit the HCP account information for creating a new HCP account.</p>
            </div>
            <!--<div class="item">
              <span :class="{'es5':isIt||isFr}">{{$t('uername')}}:</span>
              <label class="ID">{{profile.username}}</label>
            </div>-->
            <div class="item"><span>{{$t('country_region')}}:</span>

              <select v-if="!isCN" class="country_region" v-model="profile.country_region" id="country_region">
                <option value="GB">United Kingdom (mmol/L)</option>  <!-- 英国 -->
                <option value="AU">Australia (mmol/L)</option>  <!-- 澳大利亚 -->
                <!--<option value="CN">中国 (mmol/L)</option>-->  <!-- 中国 -->
                <option value="HKF">香港(中国) (mmol/L)</option>  <!-- 中国香港 -->
                <option value="TH">Thailand (mg/dL)</option>  <!-- 泰国 -->
                <option value="ID">Indonesia (mg/dL)</option>  <!-- 印度尼西亚 -->
                <option value="MY">Malaysia (mmol/L)</option>    <!-- 马来西亚 -->
                <option value="IN">India (mg/dL)</option>   <!-- 印度 -->
                <option value="FR">France (mg/dL)</option>  <!-- 法国 -->
                <option value="DE">Deutschland (mg/dL)</option>  <!-- 德国 -->
                <option value="DD">Deutschland (mmol/L)</option>  <!-- 德国 -->
                <option value="HU">Magyarország (mmol/L)</option>  <!-- 匈牙利 -->
                <option value="IT">Italia (mg/dL)</option>    <!-- 意大利 -->
                <option value="NL">Nederland (mmol/L)</option>  <!-- 西班牙 -->
                <option value="Nor">Norge (mmol/L)</option>   <!-- 挪威 -->
                <option value="PT">Portugal (mg/dL)</option>   <!-- 葡萄牙 -->
                <option value="ES">España (mg/dL)</option>    <!-- 西班牙 -->
                <option value="SE">Sverige (mmol/L)</option>   <!-- 瑞典 -->
                <option value="TR">Turkey (mg/dL)</option>    <!-- 土耳其 -->
                <!--<option value="AE">United Arab Emirates (mg/dL)</option> -->    <!-- 阿联酋 -->
                <option value="Ro">Romania (mg/dL)</option>   <!-- 罗马尼亚 -->
                <option value="CZ">Czech republika (mmol/L)</option>  <!-- 捷克 -->
                <option value="SK">Slovenska republika (mmol/L)</option>   <!-- 斯洛伐克 -->
                <option value="LT">Lithuania (mmol/L)</option>   <!-- 立陶宛 -->
                <option value="PL">Polska (mg/dL)</option>    <!-- 波兰 -->
                <option value="DK">Danmark (mmol/L)</option>   <!-- 丹麦 -->
                <option value="FI">Suomi (mmol/L)</option>    <!-- 芬兰 -->
                <option value="CH">Switzerland (mmol/L)</option>  <!-- 瑞士 -->
                <option value="SA">Saudi  (mg/dL)</option>    <!-- 沙特 -->
                <option value="AE">United Arab (mmol/L)</option>  <!-- 阿联酋 -->
                <option value="QA">Qatar  (mmol/L)</option>   <!-- 卡塔尔 -->
                <option value="QW">Kuwait (mmol/L)</option>   <!-- 科威特 -->
                <!-- 2020.3.16 新增 -->
                <option value="RH">Croatia (mmol/L)</option>   <!-- 克罗地亚 -->
                <option value="AT">Austria (mg/dL)</option>   <!-- 奥地利 -->
                <option value="SI">Slovenia (mmol/L)</option>   <!-- 斯洛文尼亚 -->
                <option value="EE">Estonia (mmol/L)</option>   <!-- 爱沙尼亚 -->
                <option value="LV">Latvia (mmol/L)</option>   <!-- 拉脱维亚 -->
                <option value="BA">Bosnia and Herzegovina (mmol/L)</option>   <!-- 波黑  -->
                <option value="BG">Bulgaria (mmol/L)</option>   <!-- 保加利亚 -->
                <option value="CL">Chile (mmol/L)</option>   <!-- 智利 -->
                <option value="BE">Belgium (mg/L)</option>   <!-- 比利时 -->
              </select>
              <label v-else class="ID2">中国 (mmol/L)</label>

            </div>

            <div class="item">
              <span :class="{'es5':isIt||isFr||isDe||isEs||isDu||isPo||isSw}">{{$t('Name')}}</span>
              <input class="name"  v-model="profile.realname" >
            </div>

            <div class="item" v-show="true">
              <span>{{$t('Organization')}}</span>
              <input class="name org" v-model="profile.serve_for"  :class="{'zh2':!isEn,'es2':isEs,'it2':isIt,'cz2':isCz}" >
            </div>

            <!--
            <div class="item"><span class="addSpan">{{$t('Address')}}</span>
              <input class="address" v-model="profile.address" :value='profile.address'>
              <input class="address" v-model="address2">
            </div>
            <div class="item post"><span>{{$t('Postcode')}}</span><input class="name" v-model="profile.zipcode" :value='profile.zipcode'></div>-->
            <div class="item"><span >{{$t('Email')}}</span><input class="name" v-model="profile.email" ></div>
            <div class="item"><span>{{$t('Mobile')}}</span><input class="name" v-model="profile.mobile" ></div>

            <!--
            <div class="item"><span >{{$t('Telephone')}}</span><input class="name" v-model="profile.telephone" :value='profile.telephone'></div>
            <div class="item email"><span >{{$t('Bio')}}</span><input class="name" v-model="profile.motto" :value='profile.motto'></div>-->
          </div>

          <div class="operate" :class="{'opeP':isP}">
            <!--<button class="cancel" @click="back">{{$t('Cancel')}}</button>
            <button class="create" @click="create1" v-show="isP">{{$t('save')}}</button>
            <button class="create" @click="create2" v-show="isD">{{$t('save')}}</button>-->
            <button class="create" @click="create2" v-show="true">Create</button>
          </div>

        </div>

        <div v-show="tabB">
          <p class="update-to-hcp-text">
            This email address has been used by a patient account. If you want to switch to an HCP account, choose Next. <br/>
            Please note that once the account type is changed, any account data will be lost, and you can’t log in anymore to this account on EasyTouch, EasySense or EasyPatch.

          </p>

          <div class="operate" :class="{'opeP':isP}">
            <button class="create" @click="nextProc" v-show="true">Next</button>
            <button class="cancel" @click="backProc">{{$t('Cancel')}}</button>
          </div>

        </div>

        <div v-show="tabC">
          <p class="update-to-hcp-text">
            This email address has been used by a caregiver account. If you want to switch to an HCP account, choose Next. <br/>
            Please note that once the account type is changed, any account data will be lost, and you can’t log in anymore to this account on EasyFollow.

          </p>

          <div class="operate" :class="{'opeP':isP}">
            <button class="create" @click="nextProc" v-show="true">Next</button>
            <button class="cancel" @click="backProc">{{$t('Cancel')}}</button>
          </div>

        </div>

        <div v-show="tabD">
          <div class="success_wrap">
            <p><img src="../../assets/icon_ok.png"/></p>
            <p>Account created.</p> <br/> <br/> <br/>
            <button class="add_new" @click="addNewProc">+ Add new account</button>
          </div>
          <div class="success_wrap">

          </div>
        </div>

      </el-card>

      <div class="Hcp-footer">
       <span>
<!--         <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->

         <a :href="contactURL">{{ $t('contact us') }} </a>
              <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
              <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

          {{$t('copyright')}} <br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
       </span>
      </div>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth/auth'
      import format from '@/lib/format'
  export default{
    data(){
      return{
        isCN: false,
        realname:'',gender:'',height:'',weight:'',  isP:true,isD:false,isM:false,isEs:false,isDe:false,isCz:false,
        birthday:'',value2:'',value3:'',isEn:false,isIt:false,isPo:false,isFr:false,isDu:false,isZh:false,isSw:false,
        birthdayShow:'',disDateShow:'',
        tabA:true,tabB:false,tabC:false,tabD:false,
        dis_type:'11',
        diabetes_type:'',diabetes_diagnosis_date:'',

        address1:'', address2:'', postcode:'', mobile:'', telephone:'', email:'',

        profile:'',  imageUrl: '',uid:0,newPortrait:'',usterType:'',
        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now();
          }
        },
        isEU:true,
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
      }
    },
    computed:{
      portrait(){
        if(this.imageUrl){
          return this.imageUrl;
        }else{
          return '/api/v2.0/person/'+parseInt(sessionStorage.getItem('uid'))+'/portrait'
        }
      }
    },
    methods:{
      navToHome() {
        this.$router.push('/accountsadmin_home')
      },
      checkInput(info){
       if(this.profile.email){
         let re =  /@/;
         if(re.test(this.profile.email)){
           auth.modifyPersonProfile(this,info);
         }else{
           alert('Email Error!');
         }
       }else{
         auth.modifyPersonProfile(this,info);
       }
      },
      checkInput2(info){
        let res=true;
        let tip=''
        if (!this.isCN) {
          if (!this.profile.country_region) {
            //alert('Select country/region');
            tip += 'Select country/region \n'
            res=false;
          }
        }
        if (!this.profile.realname) {
          //alert('Input name');
          tip += 'Input name \n'
          res=false;
        }
        if (!this.profile.serve_for) {
          //alert('Input organization info');
          tip += 'Input organization info \n'
          res=false;
        }
        if (!this.profile.email) {
          //alert('Input email info');
          tip += 'Input email info \n'
          res=false;
        } else {
          let re=/@/;
          if (!re.test(this.profile.email)) {
            tip += 'Input correct email \n'
            res=false;
          }
        }
        if (!this.profile.mobile) {
          //alert('Input mobile info');
          tip += 'Input mobile info \n'
          res=false;
        } /*else {
          let re=/^\d*$/;
          if (!re.test(this.profile.mobile)) {
            tip += 'Input correct mobile \n'
            res=false;
          }
        }*/

        if (!res) {
          alert(tip);
        }


        return res;
      },
      back(){
        if(this.usterType==='D'){
          this.$router.push('/PatientList');
        }else if(this.usterType==='M'){
          this.$router.push('/carerConnection');
        }else{
          this.$router.push('/monitor');
        }
      },

      create1(){
        let bthday = '';
        if(typeof this.profile.birthday!== 'string'&&this.profile.birthday!==undefined){
           bthday =format.formatterDate3(this.profile.birthday.getTime()/1000);
        }else{
          bthday =this.profile.birthday;
        }

        let diagonosis_date = '';
        if(typeof this.profile.diabetes_diagonosis_date!== 'string'&&this.profile.diabetes_diagonosis_date!==undefined){
          diagonosis_date =format.formatterDate3(this.profile.diabetes_diagonosis_date.getTime()/1000);
        }else{
          diagonosis_date =this.profile.diabetes_diagonosis_date;
        }

        const obj1 =document.getElementById('dis_type');
        let dis_type = obj1.value;
        const obj2 =document.getElementById('gender');
        let gender = obj2.value;

        let info = {
          realname:this.profile.realname,
          gender:gender,
          height:this.height||this.profile.height,
          weight:this.weight||this.profile.weight,
          birthday:bthday,
          diabetes_type:dis_type,
          diabetes_diagonosis_date:diagonosis_date,
          address:this.profile.address+this.address2,
          zipcode:this.profile.zipcode,
          mobile:this.profile.mobile,
          telephone:this.profile.telephone,
          email:this.profile.email,
          motto:this.profile.motto,
          country:this.profile.country_region
        };
        if(this.newPortrait.length>1){
          info.portrait = this.newPortrait;
        }
        this.checkInput(info);
      },
      backProc(){
        this.tabB=false;
        this.tabC=false;
        this.tabA=true;
      },
      addNewProc(){
        this.profile.realname = '';
        this.profile.email = '';
        this.profile.mobile = '';
        this.profile.serve_for = '';
        this.profile.country_region = '';
        this.tabD=false;
        this.tabA=true;
      },
      nextProc(){
        let param = {
          //info:{
            name:this.profile.realname,
            org:this.profile.serve_for,
            country:this.profile.country_region,
            email:this.profile.email,
            phone:this.profile.mobile,
            flag:'direct_update'
            //test:'yes'
          //}
        }

        this.$http.post('/api/v2.1/hcp/update_to_hcp', param).then(function(res){
          console.log('update_to_hcp:', res);
          let error=res.data.error;
          if (0==error) {
            this.tabB=false;
            this.tabC=false;
            this.tabD=true;
          }
        },function(err){

        })
      },
      create2(){
        if (false) {
          let bthday = '';
          if(typeof this.profile.birthday!== 'string'&& this.profile.birthday!==undefined){
            bthday =format.formatterDate3(this.profile.birthday.getTime()/1000);
          }else{
            bthday =this.profile.birthday;
          }
          const obj2 =document.getElementById('gender');
          let gender = obj2.value;
          const obj3 =document.getElementById('major');
          let major = obj3.value;

          let info = {
            realname:this.profile.realname,
            gender:gender,
            birthday: bthday,
            serve_for:this.profile.serve_for,
            major:major,
            address:this.profile.address+this.address2,
            zipcode:this.profile.zipcode,
            mobile:this.profile.mobile,
            telephone:this.profile.telephone,
            email:this.profile.email,
            motto:this.profile.motto,
          };
          if(this.newPortrait.length>1){
            info.portrait = this.newPortrait;
          }
          this.checkInput(info);
        }
        let info = {
          realname:this.profile.realname,
          mobile:this.profile.mobile,
          email:this.profile.email,
          serve_for:this.profile.serve_for,
          country:this.profile.country_region
        }
        console.log('info:', info);
        if (this.checkInput2(info)) {
          // 参数检查通过， 发送请求。
          let param = {
            info:{
              name:this.profile.realname,
              org:this.profile.serve_for,
              country:this.profile.country_region,
              email:this.profile.email,
              phone:this.profile.mobile,
              test:'yes',
              flag:'direct_create'
            }
          }

          this.$http.post('/api/v2.0/hcp/apply', param).then(function (res) {
            console.log('res:', res);
            let error=res.data.error;
            let user_type=res.data.user_type;
            if (3==error) {
              if ('D'==user_type) {
                this.$message.error('HCP account exist.');
                //return
              } else if ('P'==user_type) {
                this.tabA=false;
                this.tabB=true;
              } else if ('M'==user_type) {
                this.tabA=false;
                this.tabC=true;
              }
            } else if (0==error) {  // 直接创建hcp账号
              this.tabA=false;
              this.tabD=true;
            } else {
              this.$message.error('error:'+error);
            }
          }, function (err) {

          });
        }
      },
      create3(){
        if (false){
          let bthday = '';
          if(typeof this.profile.birthday!== 'string'&& this.profile.birthday!==undefined){
            bthday =format.formatterDate3(this.profile.birthday.getTime()/1000);
          }else{
            bthday =this.profile.birthday;
          }
          const obj2 =document.getElementById('gender');
          let gender = obj2.value;
          let info = {
            realname:this.profile.realname,
            gender:gender,
            birthday:bthday,
            address:this.profile.address+this.address2,
            zipcode:this.profile.zipcode,
            mobile:this.profile.mobile,
            telephone:this.profile.telephone,
            email:this.profile.email,
            motto:this.profile.motto,
          };
          if(this.newPortrait.length>1){
            info.portrait = this.newPortrait;
          }
          this.checkInput(info);
        }
      },

      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.newPortrait = res.path;
        //console.log(res,res.path);
      },
      beforeAvatarUpload(file) {
        const isJPG = (file.type === 'image/jpeg'||file.type === 'image/jpg'||file.type === 'image/png');
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      }
    },
    mounted(){
      this.uid = parseInt(sessionStorage.getItem('uid'));
      this.usterType = sessionStorage.getItem('userType');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isZh= (lang==='zh')?true:false;
      this.isSw= (lang==='sw')?true:false;
      this.isCz= (lang==='cz')?true:false;
      if(this.usterType==='P'){this.isP =true;this.isD =false;this.isM =false;}
      if(this.usterType==='D'){this.isD =true;this.isP =false;this.isM =false;}
      if(this.usterType==='M'){this.isM =true;this.isD =false;this.isP =false;}
      let countryIndex=localStorage.getItem('index');
      //console.info('countryIndex:'+countryIndex);
      if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
        this.isEU=false;
      }
      this.isCN = this.isZh;
      //auth.getProfile(this);
      this.profile={};
      this.profile.realname = ''
      this.profile.email = ''
      this.profile.mobile = ''
      this.profile.serve_for = ''
      this.profile.country_region = ''

      setTimeout(()=>{
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)
    },
  }
</script>
<style scoped>
  .newPatient-container{
    min-height:689px;
    width:100%;
    background-color:#fff;
  }
  .container{
    width:62%;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  @media screen and (max-width: 1500px){
    .container{
      width:92%;
    }
  }
  @media screen and (min-height: 950px){
    .container{
      min-height:900px;
    }
  }
  .main-container{
    width:97%;
    min-height: 539px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    position: relative;
  }
  .main-header{
    width: 98%;
    margin:0 auto;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:70px;
    height:20px;
    line-height: 20px;
    margin-right: 1%;
  }
  .de22{
    width:90px;
  }
  .cz22{
    width:80px;
  }
  .main-header-right img{
    display: block;
    margin-top: 5px;
    float: left;
  }
  .main-header-right p{
    float:right;
    color:#0082d2;
    margin-top: 2px;
    cursor: pointer;
  }
  .small-hr{
    background:#e6e8ea;
    width:98%;
    height:1px;
    margin:0 auto 15px;
    border:none;
  }

  .item-wrap{
    width:96%;
    margin:0 auto;
  }
  .item{
    width:95%;
    height:37px;
    line-height: 37px;
    margin-bottom: 15px;
  }
  .item span{
    width:120px;
    height: 100%;
    float: left;
    display: inline-block;
  }
  .item.intro-text {
    margin-bottom: 50px;
  }
  .ID{
    *color:#0082d2;
    color:#000;
    margin-left: 50px;
  }
  .ID2 {
    margin-left: 50px;
  }
  .portrait{
    margin-bottom: 15px;
  }
  .portrait .porSpan{
    width: 150px;
  }
  .portrait img{
    background:#c9c9c9;
    border-radius:100px;
    width:51px;
    height:50px;
    margin-left: 15px;
    margin-top: -10px;
  }
  .item .name{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:298px;
    height:35px;
    font-size:16px;
    margin-left: 40px;
    padding-left:8px;
    color:#282828;
    font-family:SFUIText-Regular;
  }
  .item select{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:159px;
    height:35px;
    font-size:16px;
    margin-left: 40px;
    color:#282828;
    padding-left: 6px;
    font-family:SFUIText-Regular;
  }
  .item select.country_region {
    width:300px;
  }
  .item option{
    color: #282828;
    font-family:SFUIText-Regular;
  }
  .item .height{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:151px;
    height:34px;
    font-size:16px;
    margin-left: 40px;
    color:#282828;
    padding-left: 6px;
    font-family:SFUIText-Regular;
  }
  .item .spe-span{
    height:20px;
    line-height: 20px;
    width:120px;
    display: block;
    float: left;
    margin-right: 0px;
  }
  .item .addSpan{
    height:60px;
  }
  .item .address{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:60%;
    height:35px;
    margin-left: 40px;
    margin-bottom: 12px;
    padding-left: 8px;
    color:#282828;
    font-size: 16px;
    font-family:SFUIText-Regular;
  }
  .post{
    clear: both;
    margin-top: 65px;
  }
  .email{
    margin-bottom: 30px;
  }
  .item .unit{
    float:none;
    margin-left: 4px;
    font-size: 18px;
  }

  .item .block{
    margin-left: 40px;
    float: left;
  }
  .item .profession{
    margin-left: 53px;
    width: 185px;
  }
  .item .de1{
    margin-left: 93px;
  }
  .item .org{
    margin-left: 40px;
  }
  .item .zh1{
    margin-left: 99px;
  }
  .item .zh2{
    margin-left: 63px;
  }
  .item .zh3{
    width: 63px;
    margin-right: 36px;
  }
  .el-date-editor.el-input{
    width:159px;
  }
  .item .es1{
    margin-left: 62px;
  }
  .item .es2{
    margin-left: 33px;
  }
  .item .es5{
    width:120px;
    height: 20px;
    line-height: 20px;
    float: left;
    display: inline-block;
    margin:0;
  }
  .item .it1{
    margin-left: 44px;
  }
  .item .it2{
    margin-left: 16px;
  }
  .item .po1{
    margin-left: 62px;
  }
  .item .fr1{
    margin-left: 85px;
  }
  .item .sw1{
    margin-left:100px;
  }
  .item .cz1{
    margin-left:70px;
  }
  .item .cz2{
    margin-left:47px;
  }
  .operate{
    width: 70%;
    float: right;
    margin-top:50px;
    position: absolute;
    bottom: 20px;
    right: 25px;
  }
  .opeP{
    position: inherit;
    margin:50px 25px 20px 0;
  }
  .operate button,
  .add_new{
    *background: transparent;
    background-image: linear-gradient(90deg,#42c3fd,#55adf8);
    color:#fff;
    border:1px solid #a3a3a3;
    border-radius:100px;
    width:150px;
    height:30px;
    outline: none;
    cursor: pointer;
    float: right;
  }

  .add_new{
    float: none;
    margin-left:20px;
  }
  .operate .cancel{
    margin-right: 20px;
    background-image: linear-gradient(90deg,#aaa,#aaa);
  }

  .update-to-hcp-text {
    font-size:26px;
    color:red;
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }

  input::-webkit-input-placeholder{
    color: #282828 !important;
  }
  input:-moz-placeholder{
    color: #282828 !important;
  }
  input::-moz-placeholder{
    color: #282828 !important;
  }
  input:-ms-input-placeholder{
    color: #282828 !important;
  }

  .xx_country_region {
    width:300px;
  }
  .success_wrap {
    width:30%;
    margin:20px auto;
  }
  .success_wrap p{
    float:left;
    line-height: 40px;
  }
  .success_wrap p:first-child {
    margin-right:10px;
  }
</style>



// WEBPACK FOOTER //
// create-hcp.vue?9f588e58